import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Alert,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from '../../api/axios';

const PrivacyPolicyManager = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      ['link', 'image'],
      [{ align: [] }],
      [{ color: [] }, { background: [] }],
      ['blockquote', 'code-block'],
      ['clean'],
    ],
  };

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await axios.get('/privacy-policy/public');
      setContent(response.data.content || '');
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setError('Ошибка загрузки политики конфиденциальности');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        '/privacy-policy',
        { content },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setSuccess('Политика конфиденциальности успешно обновлена');
      setTimeout(() => setSuccess(''), 3000);
    } catch (error) {
      console.error('Error updating privacy policy:', error);
      setError('Ошибка при обновлении политики конфиденциальности');
    }
  };

  if (loading) {
    return (
      <Box>
        <Typography>Загрузка...</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight={600}>
          Политика конфиденциальности
        </Typography>
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleSave}
          disabled={!content}
        >
          Сохранить
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
          {success}
        </Alert>
      )}

      <Paper sx={{ p: 2 }}>
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          modules={modules}
          style={{ height: '500px', marginBottom: '50px' }}
          placeholder="Введите текст политики конфиденциальности..."
        />
      </Paper>

      <Box sx={{ mt: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Совет:</strong> Политика конфиденциальности должна содержать информацию о том, 
          какие данные собираются, как они используются и защищаются. Обновите текст в соответствии 
          с требованиями законодательства о персональных данных.
        </Typography>
      </Box>
    </Box>
  );
};

export default PrivacyPolicyManager;
